// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/beaufort-wind-estimation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/beaufort-wind-estimation/beaufort-wind-estimation.js';

mount([g0]);
